import { editBotConstants } from '../constants';

const editGeneratorBot = (state, action) => {
    if (state === undefined) {
        return {
            editGeneratorBot: {},
            loading: false,
            error: null,
            success: false,
        };
    }

    switch (action.type) {
        case editBotConstants.EDIT_BOT_REQUEST:
            return {
                editGeneratorBot: {},
                loading: true,
                error: null,
                success: false,
            };

        case editBotConstants.EDIT_BOT_SUCCESS:
            return {
                editGeneratorBot: action.payload,
                loading: false,
                error: null,
                success: true,
            };

        case editBotConstants.EDIT_BOT_FAILURE:
            return {
                editGeneratorBot: {},
                loading: false,
                error: action.payload,
                success: false,
            };

        default:
            return state;
    }
};

export default editGeneratorBot;
